import { ChordPickerBar } from '@/types.ts';
import ChordButton from '@/components/ChordButton/ChordButton.tsx';
import useProgression from '@/hooks/useProgression.ts';

interface ChordPickerProps {
  picker: ChordPickerBar;
  pickerIndex: number;
}

function ChordPicker({ picker, pickerIndex }: ChordPickerProps) {
  const { selectedChord, setSelectedChord } = useProgression();

  return (
    <div className="flex flex-col">
      <h3 className="uppercase mb-2 text-sm sm:text-base">
        {picker.name}
      </h3>
      <div className="flex justify-start gap-1 sm:gap-2 flex-wrap">
        {picker.options.map((option, index) => (
          <ChordButton
            key={option.numeral}
            disabled={!picker.isEnabled(index)}
            option={option}
            selected={selectedChord && pickerIndex === selectedChord[0] && index === selectedChord[1]}
            onClick={() => setSelectedChord(pickerIndex, index)}
          />
        ))}
      </div>
    </div>
  );
}

export default ChordPicker;
